import { Plugin } from "prosemirror-state";
import { DecorationSet } from "prosemirror-view";
import { findChildren } from "prosemirror-utils";
import flatMap from "lodash/flatMap";
import { createSectionDecorations, findChildHeadings } from "../helpers";
/**
 * Manage decorations for collapsed nodes.
 *
 * Collapsed headings should make all content inside their section to be hidden.
 * We achieve that by applying decorations to the nodes. The decoration just add a "collapsed" class to the node.
 *
 * A node is considered to be inside the section of its previous sibling heading, based on the level of the heading.
 */
export function HeadingCollapsePlugin() {
    return new Plugin({
        state: {
            init(config, state) {
                return createCollapseDecorations(state);
            },
            apply(transaction, set, oldState, newState) {
                if (!transaction.docChanged) {
                    set = set.map(transaction.mapping, transaction.doc);
                    return set;
                }
                return createCollapseDecorations(newState);
            },
        },
        props: {
            decorations(state) {
                return this.getState(state);
            },
        },
    });
}
/**
 * Look for all headings nodes and create `collapse` DecorationSet for the nodes inside their section.
 */
export function createCollapseDecorations(state) {
    const visitedChilds = new Set();
    const nodes = findChildren(state.doc, (node) => {
        const attrs = node.attrs;
        return node.type === state.schema.nodes.heading && attrs.collapse;
    }, false);
    const filteredNodes = nodes.filter((node) => {
        if (!visitedChilds.has(node.node.attrs.id)) {
            const children = findChildHeadings(state, node).map((child) => child.node.attrs.id);
            children.forEach((id) => visitedChilds.add(id));
            return true;
        }
        return false;
    });
    const decorations = flatMap(filteredNodes, ({ node, pos }) => createSectionDecorations(state, { node, pos }, () => ({ class: "collapsed" }), false));
    return DecorationSet.create(state.doc, decorations);
}
